<template>
  <div class="animated fadeIn">
    <b-card>

      <!-- HEADER -->
      <template #header>
        <div class="d-flex align-items-center">
          <strong class="mr-auto">SRID CHECK</strong>
        </div>
      </template>

      <div id="listloader" v-if="loader">
        <div class="listloader"></div>
      </div>


       <b-form
        @submit.prevent="validateForm('form-1')"
        data-vv-scope="form-1"
        >
        <b-row class="align-items-end">

            <!-- LEFT SIDE -->
            <b-col md="8">
            <b-form-group>
                <b-row>
                <b-col sm="3">
                    <label>
                    <b>Load Id</b>
                    </label>
                    &nbsp;<span style="color:red">*</span><b>:</b>
                </b-col>

                <b-col sm="9">
                    <vue-tags-input
                    v-model="loadid"
                    :tags="tags"
                    @tags-changed="(newTags) => (tags = newTags)"
                    :avoidAddingDuplicates="avoidAddingDuplicates"
                    :placeholder="placeholder"
                    ref="taginput"
                    :separators="[',', ';']"
                    />

                    <div class="mt-1">
                    <span class="badge badge-success1">&nbsp;</span>&nbsp;
                    <label>Unique Load Id</label>

                    <span class="badge badge-success2 ">&nbsp;</span>&nbsp;
                    <label>Repeat/Duplicate Load Id</label>
                    </div>

                    <span
                    v-show="errors.has('form-1.shipmentid')"
                    class="help text-danger"
                    >
                    {{ errors.first("form-1.shipmentid") }}
                    </span>
                </b-col>
                </b-row>
            </b-form-group>
            </b-col>

            <!-- RIGHT SIDE BUTTONS -->
            <b-col
            md="4"
            class="d-flex justify-content-end align-items-center"
            >
            <b-button
                :disabled="tags.length == 0"
                class="mr-2"
                type="submit"
                size="md"
                variant="primary"
            >
                Search
            </b-button>

            <b-button
                :disabled="disabled == 0"
                @click="clear()"
                class="mr-2"
                size="md"
                variant="danger"
            >
                Clear
            </b-button>

            <b-button
                :disabled="tableData.length == 0"
                size="md"
                variant="success"
                @click="downloaddata()"
            >
                Download
            </b-button>
            </b-col>

        </b-row>
        </b-form>

         <div>
            <b-col sm="12" class="text-right">
            <p style="margin-top: 10px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
          </b-col>
            <b-table
            bordered
            small
             :busy="isBusy"
            :items="tableData"
            :fields="fields"
            class="custom-table"
            >
    
             <template slot="invoicenodata" slot-scope="row">
                 <div class="nowrap-text" style="max-width: 140px;">
                {{ row.item.invoiceno }}
                </div>
            </template>
            
            </b-table>

            <b-col md="12" class="my-1" v-if="totalRows > 0">
            <paginate 
                v-model="pageNum"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
            </paginate>
            </b-col>
        </div>

    </b-card>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  components: {
    VueTagsInput,
  },
  data: function() {
    return {
        tags: [],
        loadid:'',
        toggleInfo: false,
        avoidAddingDuplicates: false,
        placeholder: "Add Load Id/Parent AWB",
        fields: [
        { key: "invoicenodata", label: "Load ID" },
        { key: "parentawb", label: "AWB Number" },
        { key: "mpscount", label: "MPS Count" },
        { key: "shipmentstatus", label: "Current Shipment Status" },
        { key: "createddate", label: "Created Date",
             formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
                tdClass: 'text-nowrap'
            
         },
        { key: "rtodate", label: "RTO Date",
            formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : 'NA',
                tdClass: 'text-nowrap'
            
         },
        { key: "sourceaddress", label: "Source Address" },
        { key: "destinationaddress", label: "Destination Address" },
        { key: "lastupdatedhub", label: "Last Updated Hub" },
        { key: "srid", label: "SRID" },
       
      ],

      tableData: [],
      totalRows:0,
      pageNum:1,
      noofpages:'',
      currentPage: 1,
      pageOptions: [5, 10, 15],
      perPage:  10,
      loadurl:'',
      loader:false,
      isBusy: false,
    }
  },
  created(){

  },

  methods:{
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.searchfortheloadid(this.pageNum)
        }
      });
    },

    clear(){
        
        this.loadid=''
        this.tableData=[]
        this.totalRows= 0
        this.noofpages =''
        this.tags = [];
    },

    clickCallback(pageNum){
        this.searchfortheloadid(pageNum)
    },

    searchfortheloadid(pageNum){
        this.loader = true;
        this.isBusy = true;
        const obj={
            loadid: this.tags,
             page_no: `${pageNum}`,
        }

        this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/searchforthesrid`,obj
        )
        .then((result) => {
             this.loader = false;
             this.isBusy = false;
          console.log("YYY", result);
          if(result.data.returnmsg == "Successful"){
            this.tableData =  result.data.returnvalue;
            this.totalRows =  result.data.returnvalue[0].totalcount
            this.noofpages = Math.ceil(this.totalRows / this.perPage);
            // Find records where RTO date is null
            const missingRtoLoadIds = this.tableData
            .filter(item => item.rtodate == null)
            .map(item => item.invoiceno);

            // Show alert if any missing
            if (missingRtoLoadIds.length > 0) {

            this.$fire({
                text: `RTO date not available for: ${missingRtoLoadIds.join(", ")}`,
                type: "warning",
                timer: 30000,
            });

            }

          }else{
              this.$fire({
                text: result.data.returnvalue,
                type: "warning",
                timer: 30000,
            });

             this.tableData=[]
             this.tags = [];
             this.totalRows= 0
             this.noofpages =''
          }

        })
        .catch((ex) => {
             this.loader = false;
              this.isBusy = false;
          console.log("error", ex);
           this.tableData=[]
             this.totalRows= 0
             this.noofpages =''
             this.tags = [];
        });
    },
    downloaddata() {

    const obj = {
        loadid: this.tags
    };

    this.loader = true;

        this.$http
            .post(
            `${CONSTANTS.MIGRATION_API_URL}/downloadsriddata`,obj
            )
            .then((result) => {

        const blob = new Blob([result.data], {
        type: 'text/csv'
        });

        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);

        link.download = `SRID_DATA.csv`;

        document.body.appendChild(link);

        link.click();

        link.remove();

        this.loader = false;

    })

    .catch((error) => {

        console.log(error);

        this.loader = false;

    });

    }
  }


}
</script>

<style scoped>
.nowrap-text {
  white-space: nowrap;
}
</style>